import { Component, OnInit } from '@angular/core'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import { Interpolation } from 'chartist'
declare var require: any
const data: any = require('./data.json')

@Component({
  selector: 'vb-widgets-charts-13v2',
  templateUrl: './13v2.component.html',
})
export class VbChart13v2Component implements OnInit {
  chartData = data
  chartOptions = {
    lineSmooth: Interpolation.none({
      fillHoles: false,
    }),
    showPoint: true,
    showLine: true,
    showArea: true,
    fullWidth: true,
    showLabel: false,
    axisX: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    axisY: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    chartPadding: 0,
    low: 0,
    plugins: [
      ChartistTooltip({
        anchorToPoint: false,
        appendToBody: true,
        seriesName: false,
      }),
    ],
  }
  constructor() {}
  ngOnInit() {}
}
